import React, { useState, useEffect } from "react";
import { Loader } from "semantic-ui-react";
import { useAuth } from "../../../../hooks";
import { TeacherAPI } from "../../../../api";
import { RutasDidacticasWizard } from "../../../../components/Admin/RutasDidacticasComp";
import { TeacherSalasGrid } from "../../../../components/Admin/TeacherportalCmp";
import "./Page_Teacher_Salas.scss";

const teacherController = new TeacherAPI();

export function Page_Teacher_Salas() {
  const { user, accessToken } = useAuth();

  // Datos del docente
  const [teacher, setTeacher] = useState(null);

  // Control de carga
  const [loading, setLoading] = useState(true);

  // Control de paginación (si tu Grid la requiere)
  const [page, setPage] = useState(1);

  // Control de recarga
  const [reload, setReload] = useState(false);
  // Al llamarse onReload(), alternamos entre true/false
  const onReload = () => setReload((prev) => !prev);

  // Modal para crear Ruta
  const [showNewRouteModal, setShowNewRouteModal] = useState(false);
  const [forceCreateRoute, setForceCreateRoute] = useState(false);

  // ===========================
  // 1) Obtener datos del docente
  // ===========================
  useEffect(() => {
    const fetchTeacherData = async () => {
      try {
        const response = await teacherController.getTeacherById(
          accessToken,
          user?.user?.teacher
        );
        setTeacher(response.teacher);
      } catch (error) {
        console.error("Error al obtener datos del docente:", error);
      } finally {
        setLoading(false);
      }
    };

    if (user?.user?.teacher) {
      fetchTeacherData();
    }
  }, [accessToken, user]);

  // ===========================
  // 2) Botón "Nueva Ruta"
  // ===========================
  const handleNewRoute = () => {
    setForceCreateRoute(true);
    setShowNewRouteModal(true);
  };

  // ===========================
  // Render principal
  // ===========================
  if (loading) {
    return (
      <Loader active inline="centered">
        Cargando datos del docente...
      </Loader>
    );
  }

  return (
    <div className="teacher-salas-page">
      <TeacherSalasGrid
        teacher={teacher}
        accessToken={accessToken}
        page={page}
        setPage={setPage}
        reload={reload}
        onReload={onReload}
        onNewRoute={handleNewRoute}
      />

      {/* Modal para Crear Nueva Ruta */}
      {showNewRouteModal && (
         <RutasDidacticasWizard
         accessToken={accessToken}
         teacher={teacher}
         forceCreateMode={true}
         onClose={() => setShowNewRouteModal(false)}
         onReload={onReload}
       />
      )}
    </div>
  );
}  // 